module.exports = __webpack_public_path__ + "img/card-better-life.b3cd9c72.jpg";